import { render } from "./NykTag.vue?vue&type=template&id=52cbf7f2"
import script from "./NykTag.vue?vue&type=script&lang=js"
export * from "./NykTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__